import React, { ReactNode } from 'react';

import styles from './CardHeader.module.scss';

interface CardHeaderProps {
  actions: ReactNode[];
  isMenuOpen?: boolean;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ actions, isMenuOpen }) => (
  <div
    className={styles['actions']}
    data-card-actions
    style={isMenuOpen ? { visibility: 'visible' } : {}}
  >
    <div className={styles['actions-container']}>{actions}</div>
  </div>
);
